import { types, actions } from './requests'
export const GETKIT_TYPES = {
    ...types('GETKIT'),
}
export const GETKIT_ACTIONS = {
    ...actions('GETKIT'),
}